(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("myBadges", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/account/openBadges/myBadgesView.html",
            controller: ["myAccountResource", "messageService", "frameworkService", "$state", "$timeout", "$scope", MyBadgesCtrl],
            controllerAs: "vm"
        };
        function MyBadgesCtrl(myAccountResource, messageService, frameworkService, $state, $timeout, $scope) {
            var vm = this;
            vm.loading = true;
            if (!frameworkService.data.tenantFeatures.openBadges)
                $state.go("main.notFound");
            vm.getBadgesSummary = function () {
                myAccountResource.getMyBadgesSummary(function (data) {
                    vm.data = data;
                    if (vm.data.lastEarnedBadge) {
                        vm.data.lastEarnedBadge.timeAgo = moment.utc(vm.data.lastEarnedBadge.issueDate).local().fromNow();
                    }
                    vm.loading = false;
                    //	$timeout(function () {
                    //		if ($state.current.name === "main.accountBadges")
                    //			$state.go("main.accountBadges.badges");
                    //	});
                }, function (error) {
                    messageService.error(error);
                });
            };
            vm.getBadgesSummary();
            vm.loadBadges = function () {
                $state.go("main.accountBadges.badges");
            };
            vm.loadBadgeDetails = function () {
                $state.go("main.accountBadges.badgeDetails", { badgeGuid: vm.data.lastEarnedBadge.guid });
            };
            vm.uploadBadge = function () {
                $state.go("main.accountBadges.upload");
            };
            $scope.$on("updateBadgesSummary", function () {
                vm.getBadgesSummary();
            });
        }
    });
}());
